<template>
  <svg width="41" height="54" viewBox="0 0 41 54" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_12192_32)">
      <path
        d="M0.724121 47.8254C0.840875 48.2835 1.23513 48.7517 1.77606 48.869H3.41089L3.49429 48.9022V53.0524H4.51517V48.9022L4.60791 48.869H6.24419C6.79115 48.7273 7.17692 48.2835 7.29166 47.8254V47.8153H0.724121V47.8254Z"
        fill="#171A20"
      />
      <path
        d="M10.8281 53.0642H14.7119C15.2522 52.9561 15.6538 52.4772 15.7664 52.0136H9.77356C9.88542 52.4773 10.2929 52.9561 10.8281 53.0642Z"
        fill="#171A20"
      />
      <path
        d="M10.8281 50.9353H14.7119C15.2522 50.8282 15.6538 50.3491 15.7664 49.8849H9.77356C9.88542 50.3492 10.2929 50.8282 10.8281 50.9353Z"
        fill="#171A20"
      />
      <path
        d="M10.8281 48.8637H14.7119C15.2522 48.7553 15.6538 48.2767 15.7664 47.8128H9.77356C9.88542 48.2767 10.2929 48.7553 10.8281 48.8637Z"
        fill="#171A20"
      />
      <path
        d="M19.6857 48.8537H23.2737C23.8146 48.6956 24.2688 48.281 24.3796 47.8214H18.6799V50.9192H23.3449V52.0062L19.6857 52.0091C19.1123 52.17 18.626 52.5573 18.3834 53.069L18.6799 53.0635H24.3472V49.8892H19.6857V48.8537Z"
        fill="#171A20"
      />
      <path
        d="M31.8961 53.0648C32.4055 52.8475 32.6796 52.4717 32.7845 52.032H28.2528L28.2557 47.82L27.2399 47.8229V53.0648H31.8961Z"
        fill="#171A20"
      />
      <path
        d="M35.8539 48.8678H39.739C40.2786 48.7599 40.68 48.2808 40.7931 47.8174H34.8C34.912 48.281 35.3192 48.7599 35.8539 48.8678Z"
        fill="#171A20"
      />
      <path
        d="M34.9561 49.8931V53.0627H35.9665V50.9524H39.6438V53.0627H40.6535V49.8986L34.9561 49.8931Z"
        fill="#171A20"
      />
      <path
        d="M20.7606 37.4558L25.8616 8.59511C30.7237 8.59511 32.2573 9.13147 32.4787 11.3208C32.4787 11.3208 35.7403 10.0973 37.3854 7.61249C30.966 4.61994 24.5159 4.48498 24.5159 4.48498L20.7522 9.09676L20.7606 9.09618L16.9969 4.48425C16.9969 4.48425 10.5467 4.61936 4.12811 7.61191C5.77172 10.0967 9.03465 11.3202 9.03465 11.3202C9.25737 9.13075 10.7891 8.59438 15.6186 8.59091L20.7606 37.4558Z"
        fill="#171A20"
      />
      <path
        d="M20.7586 3.15288C25.9478 3.11296 31.8875 3.96047 37.9678 6.62654C38.7805 5.155 38.9894 4.50465 38.9894 4.50465C32.3427 1.85912 26.1181 0.953741 20.7579 0.93103C15.398 0.953741 9.17368 1.85926 2.52777 4.50465C2.52777 4.50465 2.82426 5.30573 3.54865 6.62654C9.62789 3.96047 15.5685 3.11296 20.7579 3.15288H20.7586Z"
        fill="#171A20"
      />
    </g>
    <defs>
      <clipPath id="clip0_12192_32">
        <rect width="40.069" height="52.1379" fill="white" transform="translate(0.724121 0.93103)" />
      </clipPath>
    </defs>
  </svg>
</template>
